import { Link } from "react-router";

const CategoryBlog = (props: any) => {
    return (
        <>
            <Link to={`/blog/categories/${props.slug}`} className="text-decoration-none text-black">
                <div className="card card-body border-0 pt-0 category-card-img" >
                    <div className=" w-100 d-flex justify-content-center">
                        <div className="image-box shadow pt-0">
                            <div className="d-flex align-items-center h-100 justify-content-center">
                                <img alt="category" src={`https://admin.ariyasteelrad.ir/uploads/files/blog/categories/${props.icon}`} />
                            </div>
                        </div>
                    </div>
                    <p className="text-center mb-0 fw-bold font-medium mt-3">
                        {props.name}
                    </p>
                </div>
            </Link>
        </>
    )
}

export default CategoryBlog;